// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../pr6433-npm11211-20261015/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../pr6433-npm11211-20261015/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cell-changed {
  background-color: #fff3cd;
  font-weight: 600;
  padding: 2px 4px;
  border-radius: 3px;
}

.change-row td {
  background-color: #f8f9fa;
  border-left: 3px solid #ffc107;
}`, "",{"version":3,"sources":["webpack://./src/app/cp/invoices/invoice-lineitems/invoice-all-history/invoice-all-history.component.scss"],"names":[],"mappings":"AAAA;EACI,yBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;AACJ;;AAEA;EACI,yBAAA;EACA,8BAAA;AACJ","sourcesContent":[".cell-changed {\n    background-color: #fff3cd;\n    font-weight: 600;\n    padding: 2px 4px;\n    border-radius: 3px;\n}\n\n.change-row td {\n    background-color: #f8f9fa;\n    border-left: 3px solid #ffc107;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
